import { Box } from "@mui/material";
import { ModalV2 } from "../../shared/modal/modal";
import { TextFieldStyled } from "../../shared/styles";
import { useEffect, useState } from "react";
import { Button } from "../../shared/button/button";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { changePassword } from "../../redux/actions/user.actions";
import { setChangePassword } from "../../redux/reducers/user";

export const ModalChangePassword = ({ open, handleClose }) => {
  const { message: changePasswordMessage, error: changePasswordError } =
    useSelector((state) => state.user.changePassword);

  const [input, setInput] = useState({
    newPassword: {
      value: "",
      isVisible: false,
    },
    confirmNewPassword: {
      value: "",
      isVisible: false,
    },
  });

  const dispatch = useDispatch();

  function handleChangeInput(e) {
    if (e?.target?.name) {
      setInput({
        ...input,
        [e.target.name]: {
          ...input[e.target.name],
          value: e.target.value,
        },
      });
    } else {
      setInput({
        ...input,
        [e]: {
          ...input[e],
          isVisible: !input[e].isVisible,
        },
      });
    }
  }

  function handleChangePassword() {
    if (input?.newPassword?.value !== input?.confirmNewPassword?.value) {
      toast.error("Passwords don't match");
      return;
    }

    const userId = localStorage.getItem("userId");

    if (userId) {
      dispatch(changePassword(input?.newPassword?.value, userId));
    } else {
      toast.error("User ID not found");
    }

    setInput({
      newPassword: {
        value: "",
        isVisible: false,
      },
    });
    setInput({
      confirmNewPassword: {
        value: "",
        isVisible: false,
      },
    });

    handleClose();
  }

  useEffect(() => {
    if (changePasswordMessage) {
      if (changePasswordError) {
        toast.error(changePasswordMessage);
      } else {
        toast.success(changePasswordMessage);
      }
    }

    dispatch(
      setChangePassword({
        message: null,
        isLoading: false,
        error: null,
      })
    );
  }, [dispatch, changePasswordMessage, changePasswordError]);

  return (
    <ModalV2
      isOpen={open}
      title={"Change password"}
      handleClose={handleClose}
      actionButtons={[
        {
          label: "Cancel",
          onClick: handleClose,
        },
        {
          label: "Change password",
          onClick: handleChangePassword,
        },
      ]}
    >
      <Box>
        <Box
          display={"flex"}
          flexDirection={"column"}
          gap={"8px"}
          px={"24px"}
          pb={"24px"}
        >
          {/* <TextFieldStyled
            name={"currentPassword"}
            value={input?.currentPassword?.value}
            placeholder={"Current password"}
            type={input?.currentPassword?.isVisible ? "text" : "password"}
            onChange={handleChangeInput}
            InputProps={{
              endAdornment: (
                <Button
                  startIcon={
                    input?.currentPassword?.isVisible ? "EyeSlash" : "Eye"
                  }
                  onClick={() => handleChangeInput("currentPassword")}
                  type={"regular"}
                />
              ),
            }}
          /> */}
          <TextFieldStyled
            name={"newPassword"}
            placeholder={"New password"}
            type={input?.newPassword?.isVisible ? "text" : "password"}
            value={input?.newPassword?.value}
            onChange={handleChangeInput}
            InputProps={{
              endAdornment: (
                <Button
                  startIcon={input?.newPassword?.isVisible ? "EyeSlash" : "Eye"}
                  onClick={() => handleChangeInput("newPassword")}
                  type={"regular"}
                />
              ),
            }}
          />
          <TextFieldStyled
            name={"confirmNewPassword"}
            placeholder={"Confirm new password"}
            type={input?.confirmNewPassword?.isVisible ? "text" : "password"}
            value={input?.confirmNewPassword?.value}
            onChange={handleChangeInput}
            InputProps={{
              endAdornment: (
                <Button
                  startIcon={
                    input?.confirmNewPassword?.isVisible ? "EyeSlash" : "Eye"
                  }
                  onClick={() => handleChangeInput("confirmNewPassword")}
                  type={"regular"}
                />
              ),
            }}
          />
        </Box>
      </Box>
    </ModalV2>
  );
};
